import { useState, useEffect } from "react";
import MenuBar from "../MenuBar";
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

export default function QualiteStackPlaneiteForm() {
  const { t, ui } = useI18n();

  const today = new Date().toISOString().split("T")[0];

  const [operator, setOperator] = useState("");

  const [formData, setFormData] = useState({
    Operateur: "",
    IDStack: "",
    ResistanceCollage: false,
    ResistanceCollageComment: "",
    Planeite: false,
    PlaneiteComment: "",
    AutresDefauts: false,
    AutresDefautsComment: "",
    Date: today,
  });

  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // Récupérer l'opérateur depuis localStorage
  useEffect(() => {
    const raw = localStorage.getItem("user");
    if (raw) {
      try {
        const u = JSON.parse(raw);
        setOperator(u.username || "");
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  // Synchroniser operator avec formData.Operateur
  useEffect(() => {
    if (operator) {
      setFormData((prev) => ({ ...prev, Operateur: operator }));
    }
  }, [operator]);

  /* ----------------------------------------------------
     HANDLERS
  ---------------------------------------------------- */
  const handleChange = (e) => {
    let { name, value, type } = e.target;

    if (type === "number" && Number(value) < 0) {
      value = "";
    }

    setFormData((s) => ({ ...s, [name]: value }));
  };

  const toggleSwitch = (flag, comment) =>
    setFormData((prev) => ({
      ...prev,
      [flag]: !prev[flag],
      [comment]: !prev[flag] ? prev[comment] : "",
    }));

  /* ----------------------------------------------------
     ROW RENDERER
  ---------------------------------------------------- */
  const renderRow = (label, field) => {
    return (
      <div style={styles.row}>
        <div style={styles.cellLabel}>{label}</div>
        <div style={styles.cellInput}>{field}</div>
      </div>
    );
  };

  /* ----------------------------------------------------
     SUBMIT
  ---------------------------------------------------- */
  const handleSubmit = async () => {
    setMsg("");
    setLoading(true);

    try {
      const r = await apiFetch("/api/qualite/stack_planeite/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const out = await r.json();
      setMsg(out.message || "Erreur");
      setLoading(false);

      // Réinitialiser le formulaire si succès
      if (out.status === "success") {
        setFormData({
          Operateur: operator, // Garder l'opérateur connecté
          IDStack: "",
          ResistanceCollage: false,
          ResistanceCollageComment: "",
          Planeite: false,
          PlaneiteComment: "",
          AutresDefauts: false,
          AutresDefautsComment: "",
          Date: new Date().toISOString().split("T")[0], // Date du jour
        });
      }
    } catch (e) {
      setMsg("Erreur réseau");
      setLoading(false);
    }
  };

  /* ----------------------------------------------------
     RENDER
  ---------------------------------------------------- */
  return (
    <div style={styles.page}>
      <MenuBar active="qualite" />

      <div style={styles.wrap} className="wrap">
        <section style={styles.panel}>
          <div style={styles.panelTitle}>CONTRÔLE STACK ABOUTE</div>

          <div style={styles.card}>
            <div style={styles.tableHeader}>PARAMÈTRES</div>

            <div style={styles.formAndActions}>
              <div style={styles.form}>
                {/* DATE */}
                {renderRow(
                  "DATE",
                  <input
                    type="date"
                    name="Date"
                    value={formData.Date}
                    onChange={handleChange}
                    style={styles.input}
                  />
                )}

                {/* OPERATEUR */}
                {renderRow(
                  "OPÉRATEUR",
                  <input
                    type="text"
                    name="Operateur"
                    value={
                      operator
                        ? operator.toUpperCase()
                        : "OPÉRATEUR NON CONNECTÉ"
                    }
                    readOnly
                    style={styles.input}
                  />
                )}

                {/* ID STACK */}
                {renderRow(
                  "ID STACK",
                  <input
                    name="IDStack"
                    value={formData.IDStack}
                    onChange={handleChange}
                    style={styles.input}
                  />
                )}

                {/* DÉFAUTS */}
                <DefautRow
                  label="Délamination"
                  flag="ResistanceCollage"
                  comment="ResistanceCollageComment"
                  formData={formData}
                  toggleSwitch={toggleSwitch}
                  handleChange={handleChange}
                />
                <DefautRow
                  label="Planéité / rectitude"
                  flag="Planeite"
                  comment="PlaneiteComment"
                  formData={formData}
                  toggleSwitch={toggleSwitch}
                  handleChange={handleChange}
                />
                <DefautRow
                  label="Autres défauts"
                  flag="AutresDefauts"
                  comment="AutresDefautsComment"
                  formData={formData}
                  toggleSwitch={toggleSwitch}
                  handleChange={handleChange}
                />
              </div>

              {/* ACTIONS */}
              <div style={styles.actions}>
                <button style={styles.btnAction} onClick={handleSubmit}>
                  {loading ? "Envoi..." : "CONFIRMER + ENVOYER"}
                </button>

                {msg && (
                  <div style={{ textAlign: "center", fontWeight: 800 }}>
                    {msg}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

/* ---------------- DÉFAUT ROW ---------------- */
function DefautRow({
  label,
  flag,
  comment,
  formData,
  toggleSwitch,
  handleChange,
}) {
  const isOn = formData[flag];

  return (
    <div style={styles.defautRow} className="defautRow">
      <div style={styles.defautBtn}>{label}</div>

      {/* Switch */}
      <Switch isOn={isOn} onToggle={() => toggleSwitch(flag, comment)} />

      {/* Champ commentaire */}
      {isOn && (
        <input
          type="text"
          name={comment}
          placeholder="Commentaire"
          value={formData[comment]}
          onChange={handleChange}
          style={styles.inputBeige}
        />
      )}
    </div>
  );
}

/* ---------------- SWITCH COMPONENT ---------------- */
function Switch({ isOn, onToggle }) {
  return (
    <div style={styles.switchWrapper} onClick={onToggle}>
      <div
        style={{
          ...styles.slider,
          backgroundColor: isOn ? "#28d166" : "#ff4d4d",
        }}
      />
      <div
        style={{
          ...styles.sliderCircle,
          transform: isOn ? "translateX(26px)" : "translateX(0px)",
        }}
      />
    </div>
  );
}

/* ---------------- STYLES ---------------- */
const styles = {
  page: { minHeight: "100vh", background: "#063549", color: "#fff" },
  wrap: { padding: "0 16px 36px" },
  panel: {
    background: "#63686f",
    border: "1px solid #3c4046",
    padding: 16,
    marginTop: 14,
    borderRadius: 6,
  },
  panelTitle: {
    fontWeight: 800,
    textTransform: "uppercase",
    fontSize: 16,
    marginBottom: 10,
  },
  card: { background: "#e9eaed", borderRadius: 6, overflow: "hidden" },
  tableHeader: {
    background: "#d8d9db",
    padding: "10px 16px",
    fontWeight: 800,
    color: "#000",
  },
  formAndActions: { display: "grid", gridTemplateColumns: "1fr", gap: 20 },
  form: { background: "#fff", borderRadius: 6, padding: 10 },

  /* ROW */
  row: {
    display: "grid",
    gridTemplateColumns: "1fr",
    borderBottom: "1px solid #d0d0d0",
  },
  cellLabel: {
    background: "#d0d2d5",
    padding: 10,
    fontWeight: 700,
    color: "#000",
  },
  cellInput: { background: "#f4f5f7", padding: 10 },

  input: {
    width: "100%",
    height: 36,
    borderRadius: 4,
    border: "1px solid #c0c0c0",
    paddingLeft: 8,
  },

  /* DÉFAUTS */
  defautRow: {
    display: "grid",
    gridTemplateColumns: "180px 70px 1fr",
    gap: 12,
    alignItems: "center",
    marginTop: 12,
  },
  defautBtn: {
    background: "#d8d9db",
    padding: 10,
    borderRadius: 6,
    color: "#000",
    fontWeight: 700,
    textAlign: "center",
  },
  inputBeige: {
    background: "#FFE8C6",
    borderRadius: 6,
    border: "1px solid #e2c9a5",
    padding: 8,
  },

  /* SWITCH */
  switchWrapper: {
    width: 55,
    height: 28,
    position: "relative",
    cursor: "pointer",
  },
  slider: {
    position: "absolute",
    inset: 0,
    borderRadius: 34,
    transition: "0.25s",
  },
  sliderCircle: {
    position: "absolute",
    width: 22,
    height: 22,
    background: "#fff",
    borderRadius: "50%",
    left: 3,
    bottom: 3,
    transition: "0.25s",
  },

  /* MESURES */
  measureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 12,
    marginTop: 15,
  },
  measureBox: {
    background: "#d8d9db",
    borderRadius: 6,
    padding: 10,
    textAlign: "center",
  },
  measureLabel: { fontWeight: 700, color: "#000" },
  measureInput: {
    width: "100%",
    marginTop: 8,
    height: 36,
    borderRadius: 6,
    border: "1px solid #ccc",
    paddingLeft: 8,
  },

  actions: { display: "flex", flexDirection: "column", gap: 14 },

  btnAction: {
    background: "#d8d9db",
    padding: 16,
    fontWeight: 800,
    borderRadius: 6,
    cursor: "pointer",
    border: "none",
  },
};

/* ---------------- RESPONSIVE ---------------- */
const mediaStyle = document.createElement("style");
mediaStyle.innerHTML = `
@media (min-width: 640px) {
  .wrap { padding: 0 24px 36px !important; }
  .defautRow { grid-template-columns: 200px 70px 1fr !important; }
}

@media (min-width: 900px) {
  .wrap { padding: 0 40px 40px !important; }
  .formAndActions { grid-template-columns: 2fr 1fr !important; }
}

@media (min-width: 1024px) {
  .wrap { padding: 0 80px 40px !important; }
}

@media (max-width: 480px) {
  .defautRow { grid-template-columns: 1fr 60px !important; }
  .measureGrid { grid-template-columns: 1fr !important; }
}
`;
document.head.appendChild(mediaStyle);